import React from 'react';
import { useInfiniteHits } from 'react-instantsearch';
import { useEventListContext } from '../context/EventListProvider';

import EventTeaser from '../../../event-teaser/EventTeaser';

const EventListResults = () => {
  const { i18n, showLoadMore, cta } = useEventListContext();

  const { hits, results, isLastPage, showMore } = useInfiniteHits({
    showPrevious: false,
    escapeHTML: false
  });

  return (
    <div className="event-list__results">
      {hits.map((item: any) => (
        <EventTeaser
          key={item.id}
          labels={{ topline: i18n.dateRange }}
          href={item.url}
          title={item.title}
          copy={item.intro}
          hint={item.hint}
          format={item.format}
          startDate={item['start_date_timestamp']}
          endDate={item['end_date_timestamp']}
        />
      ))}

      {showLoadMore && !isLastPage && (
        <div className="event-list__pagination">
          <button
            className="button button--secondary"
            type="button"
            onClick={showMore}
          >
            <span className="typo-button">{i18n.loadMore}</span>
          </button>

          <p className="typo-copy-small">
            {i18n.pagination
              .replace('{current}', hits.length.toString())
              .replace('{max}', (results?.nbHits || 0).toString())}
          </p>
        </div>
      )}

      {cta && (
        <div className="event-list__cta">
          <a href={cta.href} className="link">
            <span className="link__label typo-copy">{cta.label}</span>
            <span className="link__icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="32"
                height="32"
                viewBox="0 0 32 32"
              >
                <path
                  fill="currentColor"
                  fillRule="nonzero"
                  d="m16 7-1.586 1.586 6.277 6.289H7v2.25h13.691l-6.277 6.289L16 25l9-9z"
                />
              </svg>
            </span>
          </a>
        </div>
      )}
    </div>
  );
};

export default EventListResults;
